// package
import classNames from "classnames";
import { useTranslation } from "react-i18next";

// componet
import Pill from "../../../common/Pill";
// styles
import styles from "./ReadyForCashout.module.scss";

const ReadyForCashout = () => {
  const { t } = useTranslation();
  return (
    <Pill
      styleName="ReadyForCashout"
      width={"18px"}
      height={"18px"}
      Lefticon={
        <img
          src={"../../../assets/images/svg/readyForCashout_status_list.svg"}
        />
      }>
      <p className={classNames(styles.text, "p2")}>
        {t("global_status_settlement")}
      </p>
    </Pill>
  );
};

export default ReadyForCashout;
